import { render, staticRenderFns } from "./LogoDS.vue?vue&type=template&id=ba6fe376&scoped=true&"
var script = {}
import style0 from "./LogoDS.vue?vue&type=style&index=0&id=ba6fe376&lang=stylus&scoped=true&"
import style1 from "./LogoDS.vue?vue&type=style&index=1&id=ba6fe376&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6fe376",
  null
  
)

export default component.exports